var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MyCustomer"}},[_c('appHeader',{attrs:{"hasBackTool":true,"targetRouterName":_vm.route,"title":'顧客通訊錄',"headerType":'logo'}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }